import React, { useState } from "react";
import CoursesCard from "../../pages/dashboard/SkillGapAnalysisTool/CoursesCard";
import TransparentButton from "../transparentButton/TransparentButton";

const MySkillsDevelopmentPlan = ({
  title,
  learningPathwayList,
  onClick,
  bookmarkedCourseIds,
  onBookmarkToggle,
  courseData,
  onStatusChange,
}) => {
  const safeLearningPathwayList = Array.isArray(learningPathwayList)
    ? learningPathwayList
    : [];

  const [showAll, setShowAll] = useState(false);
//   const visibleCourses = showAll
//     ? safeLearningPathwayList
//     : safeLearningPathwayList.slice(0, 4);

  const visibleCourses = [];

  return (
    <div className="bg-white px-4 sm:px-5 py-6 shadow-md rounded-xl">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
        <p className="text-custom-blue font-bold text-lg sm:text-xl md:text-2xl">
          {title}
        </p>
        {safeLearningPathwayList.length > 4 && (
          <div className="self-start sm:self-auto">
            <TransparentButton
              onClick={() => setShowAll(!showAll)}
              buttonText={showAll ? "Show Less" : "View All"}
            />
          </div>
        )}
      </div>

      {safeLearningPathwayList.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-10">
          <p className="text-gray-600 text-lg font-semibold">
            No skills available
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-6">
          {visibleCourses.map((course, index) => (
            <CoursesCard
              key={index}
              courseId={course?.courseId || course?.url}
              title={course?.name || course?.title}
              url={course.url}
              rating={course?.avgProductRating || course?.rating || 0}
              numProductRatings={course?.numProductRatings || 0}
              imageUrl={course?.imageUrl}
              skills={course?.skills || []}
              productDifficultyLevel={
                course?.productDifficultyLevel || "Beginner"
              }
              partners={course?.partners || []}
              isBookmarked={bookmarkedCourseIds.has(
                course?.courseId || course?.url
              )}
              onBookmarkToggle={onBookmarkToggle}
              onClick={() => onClick(course?.url)}
              onStatusChange={onStatusChange}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MySkillsDevelopmentPlan;
